module.exports = __webpack_public_path__ + "9ddcbef0ef3319b2473e7b1b92723042.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/sleeping-17.png
// module id = 1631
// module chunks = 0